module.exports = __webpack_public_path__ + "static/media/DINPro-Regular.e2513f18.woff";